import React from 'react';
import styled from 'styled-components';
import { Space } from 'styles/themeSpaces';

const StatusBadge = styled.div<{ $backgroundColor: string, $color: string, $margin: string, $width: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 22px;
  color: ${({ $color }) => $color} !important;
  padding: ${Space.spHalf} ${Space.spBase};
  margin-left: ${({ $margin }) => $margin};
  width: ${({ $width }) => $width};
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
`;

export interface ConnectionStatusBadgeProps {
  status: string;
  backgroundColor: string;
  color: string;
  className?: string;
  margin?: string;
  width?: string;
}

/**
 * Reusable connection status badge component
 * Used to display credit tracking system status
 */
const ConnectionStatusBadge: React.FC<ConnectionStatusBadgeProps> = ({
  status,
  backgroundColor,
  color,
  className = "base-strong",
  margin = Space.spBase,
  width = 'auto'
}) => {
  return (
    <StatusBadge
      className={className}
      $backgroundColor={backgroundColor}
      $color={color}
      $margin={margin}
      $width={width}
    >
      {status}
    </StatusBadge>
  );
};

export default ConnectionStatusBadge;